import httpClient from '@/api/httpClient';

const search = state => {
    const params = {
        investmentStrategyType: state.investmentStrategySelected.name,
        investmentTopic: state.investmentTopic,
        otherInvestments: state.otherInvestments,
        investmentRegion: state.investmentRegion,
        detailsFilterType: state.selectedDetailsFilterType,
        language: state.language.toUpperCase(),
    };

    return httpClient.get('model-portfolios', { params })
        .then(({ data }) => data);
};

export default {
    search,
};
